module.exports = __webpack_public_path__ + "img/blpjs01_center_004.9b444b40.png";